<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining :hide-payout="true"
                                 :button-label="'Payout history'"
                                 :button-link="'PayoutHistory'"></futurocoins-from-mining>
        <b-row>
            <b-col cols="12">
                <p>My account balance:</p>
                <p class="my_money">FND {{ money.format(accountBalance, 'fnd') }}</p>
            </b-col>
        </b-row>
        <div v-if="isVerified && pendingPayouts === 'NOT_FOUND'">
            <b-row v-for="(row, rowIndex) in methods" :key="rowIndex">
                <b-col cols="12"
                       v-if="rowIndex.length > 1"
                       style="margin-bottom: 12px;">
                    <p>{{ rowIndex }}</p>
                </b-col>
                <b-col lg="3"
                       cols="6"
                       v-for="(option, index) in row"
                       :key="index">
                    <div class="form-item form-item-radio"
                         :class="{ 'disabled' : !option.enabled }"
                         v-tippy="{ placement : 'bottom',  arrow: true }"
                         :title="GetOptionTitle(option)">
                        <label :for="'method_' + index"
                               class="form-label">
                            {{ option.name }}
                        </label>
                        <input  :id="'method_' + index"
                                name="payment_method"
                                :value="index"
                                v-model="method"
                                :disabled="!option.enabled"
                                data-vv-rules="required"
                                data-vv-as="payment method"
                                type="radio">
                        <div class="check"></div>
                    </div>
                </b-col>
                <p class="field-error--description"
                   v-show="errors.has('payment_method')">{{ errors.first('payment_method') }}</p>
            </b-row>
            <hr>
            <payout-form :method="method"></payout-form>
            <payout></payout>
        </div>
        <p style="margin-top: 30px">
            <a href="https://futurenet.club/donate"
               target="_blank"
               style="color: red">Make the donation for FutureNet Foundation <i class="mdi mdi-chevron-right"></i></a>
        </p>
        <div v-if="pendingPayouts === 'FOUND'">
            <p class="text-alert">You have pending payout.</p>
        </div>
        <div v-if="!isVerified">
            <p class="text-alert">Your account is not verified yet.</p>
            <p style="margin-bottom: 28px;">Go to profile settings and start verification.</p>
            <router-link :to="{ name: 'Profile' }"
                         class="button--primary">Profile settings</router-link>
        </div>
    </b-col>
</template>

<script>
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'
    import Payout from '../modals/Payout.vue';
    import PayoutForm from './payout/PayoutForm.vue'
    export default {
        dependencies: ['api', 'money', 'popup'],
        components: { FuturocoinsFromMining, Payout, PayoutForm },
        data () {
            return {
                amount: 0,
                method: 'bitcoin',
                methods: {
                    0: {
                        banktransfer: {
                            name: 'Bank transfer',
                            enabled: false
                        },
                        bitcoin: {
                            name: 'Bitcoin',
                            enabled: true
                        },
                        advcash: {
                            name: 'AdvCash',
                            enabled: false
                        }
                    },
                    1 : {
                        neteller: {
                            name: 'Neteller',
                                enabled: false
                        },
                        payza: {
                            name: 'Payza',
                                enabled: false
                        },
                        perfectmoney: {
                            name: 'Perfect Money',
                                enabled: false
                        },
                        stp: {
                            name: 'Stp',
                                enabled: false
                        },
                    }
                    // 'Payment via CoinDeal' : {
                    //     coindeal_futurocoin: {
                    //         name: 'FuturoCoin',
                    //         enabled: true
                    //     },
                    //     coindeal_bitcoin: {
                    //         name: 'Bitcoin',
                    //         enabled: true
                    //     },
                    //     coindeal_litecoin: {
                    //         name: 'Litecoin',
                    //         enabled: true
                    //     },
                    //     coindeal_bitcoin_cash: {
                    //         name: 'Bitcoin Cash',
                    //         enabled: true
                    //     },
                    //     coindeal_dash: {
                    //         name: 'Dash',
                    //         enabled: true
                    //     },
                    //     coindeal_ethereum: {
                    //         name: 'Ethereum',
                    //         enabled: true
                    //     }
                    // }
                },
                pendingPayouts: 'LOADING',
                progress: false,
            }
        },
        computed: {
            accountBalance () {
                return this.$store.getters.user.moneyBalance;
            },
            isVerified () {
                return this.$store.getters.user.isVerified;
            }
        },
        methods: {
            GetOptionTitle(option) {
                return option.enabled ? '' : 'Comming soon';
            }
        },
        created () {
            this.$http.get(this.api.payout.list({})).then(response => {
                let results = response.data.results.filter(function(obj){
                    return obj.status === 'new';
                });
                if (results.length >= 1) {
                    this.pendingPayouts = 'FOUND';
                } else {
                    this.pendingPayouts = 'NOT_FOUND';
                }
            }, error => {
                this.popup.show(error.data.errors[0].message)
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_colors.scss';

    .space{
        margin-bottom: 30px;
    }

    .profile-edit-data-header{
        h3{
            margin-bottom: 30px;
        }
    }

    .row-buttons{
        margin-top: 30px;
        text-align: right;
    }

    .my_money{
        padding: 20px 0;
        font-size: 1.3em;
    }

    .form-item-radio{
        margin-bottom: 20px;
        &.disabled {
            opacity: .6;
            label {
                color: $d-gray;
            }
            input {
                cursor: default;
            }
            .check {
                border-color: $d-gray;
            }
        }
    }

    .field-error{
        .check{
            background-color: rgba(250, 159, 159, 0.66)!important;
            border-color: #e82828!important;
        }
    }

    @media(min-width: 992px){
        .payout-history{
            text-align: right;
        }
    }

    @media(max-width:991px){
        .row-buttons{
            text-align: left;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/PayoutContent.vue